import { render, staticRenderFns } from "./PopupAnswer.vue?vue&type=template&id=5e4dc539&scoped=true&"
import script from "./PopupAnswer.vue?vue&type=script&lang=js&"
export * from "./PopupAnswer.vue?vue&type=script&lang=js&"
import style0 from "./PopupAnswer.vue?vue&type=style&index=0&id=5e4dc539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dc539",
  null
  
)

export default component.exports